import { render, staticRenderFns } from "./CourseSelectorCard.vue?vue&type=template&id=6e982022&scoped=true&"
import script from "./CourseSelectorCard.vue?vue&type=script&lang=js&"
export * from "./CourseSelectorCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseSelectorCard.vue?vue&type=style&index=0&id=6e982022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e982022",
  null
  
)

export default component.exports